import { MUIChip } from "@abb/arcadia-ui-react"
import { StatusCodes } from "http-status-codes"
import { useCallback, useEffect, useMemo, useState } from "react"
import { useParams } from "react-router-dom"
import { digitalManagerApi } from "../../../../../services/api"
import {
  ApplicationRoleStatus,
  ApplicationRoleUserGet,
} from "../../../../models/ApplicationRoleUser"
import { DimaFeatureShortNameEnum } from "../../../../models/Authorization"
import { useDeleteConfirm } from "../../../../../hooks/useDeleteConfirm"
import { deleteEntity } from "../../../../utils/deleteEntity"
import { getUserApplicationStatusProps } from "../../../../utils/getUserApplicationStatusProps"
import { DiMaAddButton } from "../../../partials/DiMaAddButton"
import { EntityRow, EntityTab } from "../../../partials/EntityTab"
import { createUserApplicationsColumns } from "../../../../components/Helpers"

export function UserApplicationsRoles() {
  const { userId } = useParams()
  const { requestDelete, DeleteConfirmDialog } = useDeleteConfirm()

  const [userRoles, setUserRoles] = useState<ApplicationRoleUserGet[]>([])
  const [isLoadingUserRoles, setIsLoadingUserRoles] = useState(true)

  const cols = createUserApplicationsColumns(userId, (row: EntityRow) => (
    <MUIChip {...getUserApplicationStatusProps(row.status as ApplicationRoleStatus)} />
  ))

  useEffect(() => {
    if (!userId) {
      setIsLoadingUserRoles(false)
      return
    }

    setIsLoadingUserRoles(true)
    digitalManagerApi
      .get<ApplicationRoleUserGet[]>(`/users/${userId}/roles`)
      .then((res) => {
        if (res.status === StatusCodes.OK) {
          setUserRoles(res.data)
        }
      })
      .finally(() => setIsLoadingUserRoles(false))
  }, [userId])

  const rows: EntityRow[] = userRoles.map((role) => ({
    id: `${role.application.id}/roles/${role.role.id}`,
    applicationId: role.application.id,
    applicationShortName: role.application.shortName,
    roleId: role.role.id,
    name: role.role.name,
    validityStartDate: role.validityStartDate,
    validityEndDate: role.validityEndDate,
    status: role.status,
    hasProperties: role.properties.length > 0,
  }))

  const toolbar = useMemo(
    () => (
      <DiMaAddButton
        url={`/users/${userId}/apps-roles/create`}
        feature={DimaFeatureShortNameEnum.RM}
      />
    ),
    [userId]
  )

  const handleActionMenuClick = useCallback((item: { title: string; iconName?: string }, row: EntityRow) => {
      if (item.title === "Delete") {
        requestDelete(() =>
          deleteEntity(
            `/users/${userId}/applications/${row.applicationId}/roles/${row.roleId}`
          )
        )
      }
    }, [userId, requestDelete])

  return (
    <>
      {DeleteConfirmDialog}
      <EntityTab
        rows={rows}
        cols={cols}
        isLoading={isLoadingUserRoles}
        toolbar={toolbar}
        actionItems={[{ title: "Delete", iconName: "icon_abb_dias icon-abb_delete" }]}
        onActionMenuClick={handleActionMenuClick}
      />
    </>
  )
}
